import { Button } from "@/components/ui/button";
import { useStepper } from "@/components/StepperProvider";

interface StepperNavigationProps {
    onNext?: () => Promise<void> | void;
    onBack?: () => void;
    nextDisabled?: boolean;
}

export const StepperNavigation = ({
                                      onNext,
                                      onBack,
                                      nextDisabled = false
                                  }: StepperNavigationProps) => {
    const { isFirstStep, isLastStep, nextStep, prevStep } = useStepper();

    const handleNext = async () => {
        if (onNext) {
            await onNext();
        }
        nextStep();
    };

    const handleBack = () => {
        if (onBack) {
            onBack();
        }
        prevStep();
    };

    return (
        <div className="flex justify-between mt-6">
            <Button
                variant="outline"
                onClick={handleBack}
                disabled={isFirstStep}
            >
                Back
            </Button>
            <Button
                onClick={handleNext}
                disabled={nextDisabled}
            >
                {isLastStep ? 'Finish' : 'Continue'}
            </Button>
        </div>
    );
};
